import { ProcessSamplingCondition } from '../../domain/process-sampling-condition';
import { mapper } from '../../tools/mapping/mapper';
import { ProcessSamplingConditionEntity } from '../entity';
import type { AppDB } from '../db';

export class ProcessSamplingConditionRepository {
    constructor(private readonly database: AppDB) {}


    async getProcessSamplingConditionEntityById(id: number) {
        return await this.database.processSamplingConditions.where('Id').equals(id).first(async psce => {
            return psce;
        });
    }

    async attachProcessSamplingCondition(measure: ProcessSamplingCondition, measureId: number) {
        let conditionId: number;
        const pme = mapper.map(measure, ProcessSamplingCondition, ProcessSamplingConditionEntity);

        conditionId = await this.database.processSamplingConditions.add(pme);
        await this.database.processMeasures.update(measureId, {
            ProcessSamplingConditionId: conditionId
        });

        return conditionId;
    }
}
